import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import { useParams } from 'react-router';
import * as Yup from 'yup';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import FormikInputField from 'components/common/Fields/FormikInputField';
import useAxios from 'hooks/useAxios';
import Loader from 'components/Loader';
import { PatientComment, RxComment } from 'components/Comments';
import { dateFormate, cellRendererCheck } from 'utils/columns';
import Confirm from 'components/Confirm';
import plus from "assets/icon/plus-icon.svg";

const validationSchema = Yup.object({
  comment: Yup.string().required('Comment is required'),
});

let blobFiles = [];

const Comments = (props) => {

  const API = useAxios();
  const { rxNumber, hasEditable = true, onClose,patientId, tenantID, coveredEntityID } = props;

  // const { patientId, tenantID, coveredEntityID } = useParams();
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [commentID, setCommentID] = useState(-1);

  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const patientID = parseInt(patientId);

  const [files, setFiles] = useState([]);
  const formikRef = useRef();
  const addComment = async (payload, actions) => {
    try {
      let url = `/${tenantID}/Comments`,
        variables = { ...payload, ceid: coveredEntityID };
      if (rxNumber) {
        url = `${url}/AddRxComment`;
        variables.rxNumber = parseInt(rxNumber);
      } else {
        url = `${url}/AddPatientComment`;
        variables.patientId = patientID;
      }
      const data = await API.post(url, variables, {
        headers: {
          'Content-type': 'multipart/form-data',
        },
        hideLoader: true,
      });
      if (data.status === 200) {
        setFiles([]);
        blobFiles = [];
        toast.success('Comment added successfully!');
        actions.resetForm();
        setSubmitting(false);
        onClose();
      } else {
        setSubmitting(false);
        setFiles([]);
        blobFiles = [];
      }
    } catch (error) {
      console.log(error, 'error');
      setSubmitting(false);
    }
  };
  const fetchPatientComments = async () => {
    try {
      const { data } = await API.get(
        `/${tenantID}/Comments/PatientComments/${patientID}`,
        {
          hideLoader: true,
        }
      );
      setData(data);
    } catch (error) { }
  };

  useEffect(() => {
    fetchPatientComments();
  }, []);
  const handleDeleteConfirmation = async (row) => {
    setDeleteConfirm(!isDeleteConfirm);
    if (row) setCommentID(row.commentID);
  }
  const deleteRow = async () => {
    handleDeleteConfirmation();

    let result = await API.post(`/${tenantID}/Comments/inactivecomment/${coveredEntityID}/${commentID}`, null, {
      hideLoader: true,
    });
    if (result) {
      toast.success("Item removed successfully");
      fetchPatientComments();
    }
  }


  const handleSubmit = async (values, actions) => {
    const { comment } = values;
    const { setErrors } = formikRef.current;
    if (!comment.trim()) return setErrors({ comment: 'Enter valid comment' });
    const fileObject = {};
    files.map((f, i) => {
      fileObject['file' + (i + 1)] = f;
      return f;
    });
    setSubmitting(true);
    addComment({ comment, ...fileObject }, actions);
  };

  const fileToDataUri = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.readAsDataURL(file);
    });

  const handleFiles = (f) => {
    setFiles([...files, ...f]);
  };

  const onHandleFileChange = (e) => {
    const files = e;
    handleFiles(files);
    files.forEach((data) => {
      fileToDataUri(data).then((dataUri) => {
        blobFiles.push(dataUri);
      });
    });
  };

  return (
    <>
      <Card className='border-0 shadow-top mt-0' hidden={props.hiddenCard}>
        <CardBody>
          <Row className='align-items-center'>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Prov.First Name:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.providerFirstName)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Prov.Last Name:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.providerLastName)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Provider NPI:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.providerNPI)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Fax Number:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.faxNumber)}
                  </b>
                </p>
              </FormGroup>
            </Col>
          </Row>
          <Row style={{ marginTop: "5px" }}>
            <Col md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Rx Number:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.rxNumber)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Refill No:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.refillNumber)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Date Rx Written:
                  <b className='d-block  font-weight-500'>
                    {dateFormate(props.claimData.dateRXWritten)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Date Of Service:
                  <b className='d-block  font-weight-500'>
                    {dateFormate(props.claimData.dateofService)}
                  </b>
                </p>
              </FormGroup>
            </Col>
          </Row>
          <Row style={{ marginTop: "5px" }}>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  NDC:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.ndc)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Drug Name:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.drugName)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Qty.Dispensed:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.qtyDispensed)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Days Supply:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.daysSupply)}
                  </b>
                </p>
              </FormGroup>
            </Col>
          </Row>
          <Row style={{ marginTop: "5px" }}>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  GCN Sequence No:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.gcnSequenceNumber)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='3' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Mfg.Name:
                  <b className='d-block  font-weight-500'>
                    {cellRendererCheck(props.claimData.manufacturerName)}
                  </b>
                </p>
              </FormGroup>
            </Col>
            <Col sm='6' md='6' className='pe-3'>
              <FormGroup>
                <p className='f-14 mb-0'>
                  Prov.Specialty:
                  <b style={{ "word-break": "break-all" }} className='d-block font-weight-500'>
                    {cellRendererCheck(props.claimData.providerSpecialty)}
                  </b>
                </p>
              </FormGroup>
            </Col>
          </Row>
          <br />
        </CardBody>
      </Card >
      {hasEditable && (
        <Card className='border-0 shadow-top mt-3'>
          {submitting && <Loader opacity={0.01} color='black' />}
          <CardBody>
            <Formik
              initialValues={{
                comment: '',
                files: [],
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              innerRef={formikRef}
              children={(props) => {
                return (
                  <Form>
                    <Row>
                      <Col sm='6'>
                        <FormGroup>
                          <Field
                            id='Comment'
                            name='comment'
                            type='textarea'
                            component={FormikInputField}
                            label='Comment'
                            placeholder='Comment'
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col sm='6'>
                        <FormGroup>
                          <Label>Attachment</Label>
                          <Dropzone onDrop={onHandleFileChange}>
                            {({
                              getRootProps,
                              getInputProps,
                              isDragActive,
                            }) => (
                              <section
                                className={`drop-zone ${isDragActive ? 'active' : ''
                                  }`}
                              >
                                <div {...getRootProps()}>
                                  <input {...getInputProps()} />
                                  <div className='browse'>
                                    <span>Drag and drop attachment or</span>
                                    <span className='highlight'>Browse</span>
                                  </div>
                                </div>
                              </section>
                            )}
                          </Dropzone>
                          {files?.length > 0 && (
                            <div>
                              {files.map((item) => {
                                return <div key={item.name}>{item.name}</div>;
                              })}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='d-flex justify-content-end align-items-center'>
                      <div>
                        <Button
                          color='primary'
                          type='submit'
                          className='reset'
                          size='sm'
                          disabled={submitting}
                        >
                          <span className="right_5">
                            <img src={plus} alt="" />
                          </span>{" "} Add
                        </Button>
                      </div>
                    </div>
                  </Form>
                );
              }}
            ></Formik>
            <Confirm
              isOpen={isDeleteConfirm}
              loading={loading}
              message='Are you sure you want to delete this comment?'
              onToggle={handleDeleteConfirmation}
              onCancel={handleDeleteConfirmation}
              onContinue={deleteRow}
            />
          </CardBody>
        </Card>
      )}
      <div className='border-0 mt-3 table-card'>
        <div>
          {rxNumber ? (
            <RxComment
              rxNumber={rxNumber}
              patientID={patientID}
              tenantID={tenantID}
              coveredEntityID={coveredEntityID}
              text='Comments'
              handleDeleteConfirmation={handleDeleteConfirmation}
            />
          ) : (
            <PatientComment
              patientID={patientID}
              tenantID={tenantID}
              coveredEntityID={coveredEntityID}
              text='Comments'
              handleDeleteConfirmation={handleDeleteConfirmation}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Comments;
